import PropTypes from 'prop-types';
import '../assets/assistantComponents.scss';

const AiAssistantProgressSteps = ({ steps, currentStep, ariaLabel = 'AI progress' }) => {
  const currentIndex = Math.max(0, steps.findIndex((step) => step.key === currentStep));

  return (
    <ol
      className={`ai-assistant-steps has-${steps.length}-steps`}
      aria-label={ariaLabel}
    >
      {steps.map((step, index) => {
        const state = index < currentIndex ? 'complete' : index === currentIndex ? 'current' : 'upcoming';
        return (
          <li
            className={`is-${state}`}
            key={step.key}
            aria-current={state === 'current' ? 'step' : undefined}
          >
            <span className="ai-assistant-step-icon" aria-hidden="true">
              <i className={`bi ${state === 'complete' ? 'bi-check-lg' : step.iconClass}`}></i>
            </span>
            <span className="ai-assistant-step-label">{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
};

AiAssistantProgressSteps.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconClass: PropTypes.string.isRequired,
  })).isRequired,
  currentStep: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
};

export default AiAssistantProgressSteps;
